<template>
	<table class="table">
		<tr>
			<th v-for="column in columns" v-bind:key="column.name" :style="{textAlign: column.align}">{{ column.label }}</th>
			<th v-if="actions"></th>
		</tr>
		<tr v-for="item in items" v-bind:key="item.id" @click="$emit('itemClick', item.id)">
			<td v-for="column in columns" v-bind:key="column.name" :class="'table__cell' + (column.class ? ' ' + item[column.class] : '')">
				<div v-if="!column.layout && column.filter != 'photo'" class="table__cell__item" :style="{textAlign: column.align}">{{ column.prefix }}{{ filter(item[column.name], column.filter) }}{{ column.suffix }}</div>
				<div v-if="!column.layout && column.filter == 'photo'" class="table__cell__photo" :style="{backgroundImage: 'url(' + item[column.name] + ')'}"></div>
				<div v-if="column.layout == 'profile_duplex'" class="table__cell__profile-duplex">
					<div class="table__cell__profile-duplex__photo" :style="{backgroundImage: 'url(' + item[column.photo_name] + ')'}"></div>
					<div class="table__cell__profile-duplex__duplex">
						<div class="table__cell__profile-duplex__duplex__primary">{{ column.prefix }}{{ filter(item[column.name], column.filter) }}{{ column.suffix }}</div>
						<div class="table__cell__profile-duplex__duplex__secondary">{{ column.duplex_prefix }}{{ filter(item[column.duplex_name], column.duplex_filter) }}{{ column.duplex_suffix }}</div>
					</div>
				</div>
				<div v-if="column.layout == 'profile'" class="table__cell__profile">
					<div class="table__cell__profile__photo" :style="{backgroundImage: 'url(' + item[column.photo_name] + ')'}"></div>
					<div class="table__cell__profile__item">{{ column.prefix }}{{ filter(item[column.name], column.filter) }}{{ column.suffix }}</div>
				</div>
			</td>
			<td v-if="actions">
				<div v-for="(action, idx) in actions" v-bind:key="idx" @click.stop="$emit('action', action.name, item.id)">{{ action.label }}</div>
			</td>
		</tr>
	</table>
</template>

<script>
	export default {
		props: {
			columns: Array,
			items: Array,
			actions: Array
		},
		methods: {
			filter: function (value, filter) {
				var r = filter !== undefined && filter != 'photo' ? this.$options.filters[filter](value) : value; 
				return r === null ? '-' : r;
			}
		}
	}
</script>

<style lang="scss">
	.table {
		width: 100%;
		border-collapse: collapse;
		table-layout: auto;

		& > tr {
			& > th {
				font-size: 14px;
				font-weight: bold;
				height: 60px;
				border-bottom: 4px solid #f0f0f0;
			}

			& > td {
				height: 68px;
				border-bottom: 1px solid #f0f0f0;
			}

			& > * {
				text-align: left;
				padding-right: 30px;
			}

			& > *:first-child {
				padding-left: 30px;
			}
		}

		& > tr:hover {
			& > td {
				background-color: #f7f7f7;
				cursor: pointer;
			}
		}

		&__cell {
			& > * {		
				width: 100%;
				height: 100%;
			}

			&__item {
				line-height: 66px;
				text-overflow: ellipsis;
				white-space: nowrap;
				overflow: hidden;
			}

			&__profile {
				display: grid;
				grid-template-columns: 64px auto;

				&__photo {
					margin-top: 9px;
				}

				&__item {
					line-height: 66px;
					text-overflow: ellipsis;
					white-space: nowrap;
					overflow: hidden;
				}
			}

			&__profile-duplex {
				display: grid;
				grid-template-columns: 64px auto;

				&__photo {
					margin-top: 9px;
				}

				&__duplex {
					display: grid;
					grid-template-rows: 50% 50%;

					&__primary, &__secondary {
						line-height: 18px;
						text-overflow: ellipsis;
						white-space: nowrap;
						overflow: hidden;
					}

					&__primary {
						font-size: 14px;
						padding-top: 15px;
					}

					&__secondary {
						font-size: 12px;
						padding-bottom: 15px;
						color: #a7a7a7;
					}
				}
			}

			&__photo, &__profile-duplex__photo, &__profile__photo {
				width: 48px;
				height: 48px;
				border-radius: 50%;
				background-size: cover;
				background-position: center center;
			}	
		}
	}
</style>